module.exports = __webpack_public_path__ + "img/huoke.272e4bbb.png";